import type { Comic } from "@/mocks/comics";

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition hover:-translate-y-1 hover:border-primary-300">
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={comic.cover}
          alt={`${comic.name}封面图，${comic.category}题材漫画`}
          className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-full bg-foreground-950/70 px-2 py-0.5 text-[11px] font-medium text-background-50">
          {comic.status}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-0.5 rounded-full bg-secondary-500 px-2 py-0.5 text-[11px] font-bold text-background-50">
          <i className="ri-star-fill text-[11px]"></i>
          {comic.rating}
        </span>
        <div className="absolute inset-x-0 bottom-0 flex items-end justify-between bg-gradient-to-t from-foreground-950/80 to-transparent p-2.5 text-background-50">
          <span className="text-xs">{comic.chapters}</span>
          <span className="flex items-center gap-1 text-xs">
            <i className="ri-fire-fill text-primary-400"></i> 人气
          </span>
        </div>
      </div>

      <div className="flex flex-1 flex-col gap-2 p-3">
        <h3 className="truncate text-sm font-bold text-foreground-950">{comic.name}</h3>
        <p className="truncate text-xs text-foreground-500">{comic.author}</p>
        <div className="mt-auto flex flex-wrap gap-1.5">
          <span className="rounded-full bg-primary-100 px-2 py-0.5 text-[11px] font-medium text-primary-800">
            {comic.category}
          </span>
          {comic.tags.slice(0, 2).map((t) => (
            <span
              key={t}
              className="rounded-full bg-background-100 px-2 py-0.5 text-[11px] text-foreground-500"
            >
              {t}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}